
export const Container = props => ({
  display: 'flex',
  flexDirection: 'row',
});


// WEBPACK FOOTER //
// ./src/components/ui/ButtonGroup/styles.js